/**
 * The player's destinations, in ribbon order (issue #1119; D214.1, D216,
 * D221 O1, D225). One file so `lib/flagSafeLinks.test.js` can read every
 * literal route in one place.
 *
 * `record` keeps its key (nine callers pass `current="record"`); only the
 * label changed to "Record Match" (D225). #1147 added the fifth, Dashboard,
 * in the same PR as the screen it opens (`/insights`), so no destination
 * points at a redirect (D228.4). Five is G2's maximum.
 */
export const PLAYER_DESTINATIONS = [
  { key: "record", label: "Record Match", to: "/dashboard", testId: "nav-dashboard" },
  { key: "dashboard", label: "Dashboard", to: "/insights", testId: "nav-dashboard-career" },
  { key: "plan", label: "Plan", to: "/development", testId: "nav-development" },
  { key: "grounds", label: "Grounds", to: "/grounds-map", testId: "nav-grounds" },
  { key: "learn", label: "Training & guides", to: "/learn", testId: "nav-learn" },
];

/**
 * The coach's destinations, in ribbon order (issue #1121; D221 O1, D223 Q3,
 * D183 for the name "Your players"). Training & guides opens the coach's
 * Training tab. `players` and `grounds` reuse the strip's testids
 * (`nav-coach-portal`, `nav-grounds`); `learn` reuses the player's
 * `nav-learn`, so one selector finds Training & guides for either role.
 */
export const COACH_DESTINATIONS = [
  { key: "players", label: "Your players", to: "/coach-portal", testId: "nav-coach-portal" },
  { key: "grounds", label: "Grounds", to: "/grounds-map", testId: "nav-grounds" },
  { key: "learn", label: "Training & guides", to: "/learn?tab=training", testId: "nav-learn" },
];
